module.exports = __webpack_public_path__ + "static/media/webIcons-03.58f0576d.svg";